import React, { Component } from 'react';
import PropTypes from 'prop-types';

/*
 * Inner input form component for Gaelic word
 */

class FormInput extends Component {

  /* reset form on ESC key press */
  handleKeyDown = e => {
    if (e.keyCode === 27 /*ESC key*/) {
      this.props.onResetForm();
    }
  }

  render() {
    const inputFont = {
      fontFamily: 'Roboto, sans-serif'
    };
    return (
      <div className="ui column" >
        <div className={"ui fluid icon input "+(this.props.isFetching ? "loading" : "")}
          data-tooltip="Enter double vowels for accents: aa=à, ee=è, EE=é, ii=ì, oo=ò, OO=ó, uu=ù" >

          <input 
            onKeyDown={this.handleKeyDown}
            accessKey="w"
            style={inputFont}
            className="" 
            type="text" 
            autoFocus="autoFocus" 
            placeholder="Enter Scottish Gaelic word ..."
            id="saydatum_saytext" 
            value={this.props.saytext}
            onChange={this.props.onChange}
          />

          {/*see Form.css for id "reset-icon" regarding onClick() */}
          { 
            this.props.saytext !== '' &&
            <i onClick={this.props.onResetForm} className='remove icon' id='reset-icon'></i>
          }

        </div>
      </div>
    );
  }
}

FormInput.propTypes = {
  isFetching: PropTypes.bool,
  saytext: PropTypes.string.isRequired,
  onResetForm: PropTypes.func.isRequired
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/FormInput.js